import {
  DataGrid,
  GridActionsCellItem,
  GridColDef,
  GridRowId,
  GridRowParams,
} from "@mui/x-data-grid"
import EditIcon from "@mui/icons-material/Edit"
import { Box } from "@mui/material"
import { useNavigate } from "react-router"
import { format } from "date-fns"

interface IContractsTableProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
  data: any[]
  orgId?: string
}

export default function ContractsTable({ data = [], orgId }: IContractsTableProps) {
  const navigate = useNavigate()

  const handleEditClick = (id: GridRowId) => () => {
    const replacedId = (id as string).replaceAll("#", "%23")

    if (orgId) {
      navigate(`/Administration/Contracts/${replacedId}/${orgId}`)
    } else {
      navigate(`/Administration/Contracts/${replacedId}`)
    }
  }

  const columns: GridColDef[] = [
    {
      field: "key",
      headerName: "Name",
      headerClassName: "table-header-cell",
      flex: 1,
    },
    {
      field: "division_key",
      headerName: "Division Name",
      headerClassName: "table-header-cell",
      width: 200,
    },
    {
      field: "end_date",
      headerName: "End Date",
      headerClassName: "table-header-cell",
      type: "date",
      width: 200,
      valueFormatter: (params) => format(new Date(params?.value), "RRRR-LL-dd"),
    },
    {
      field: "active",
      headerName: "Active",
      headerClassName: "table-header-cell",
      type: "boolean",
      width: 200,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      headerClassName: "table-header-cell",
      width: 160,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
      getActions: ({ id }: GridRowParams<any>) => {
        return [
          // eslint-disable-next-line react/jsx-key -- fix it when you will have a chance to check this component
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
        ]
      },
    },
  ]

  return (
    <Box className={"contracts-table-container"}>
      <DataGrid
        autoHeight
        density={"compact"}
        rows={data}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        pageSizeOptions={[10, 20]}
        getRowId={(row) => row.key}
      />
    </Box>
  )
}
